import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import { apiFetch } from "@/lib/api-fetch";

type BillingStatus = {
  has_org: boolean;
  subscription_status: string;
  trial_days_left: number;
  trial_ends_at: string | null;
};

export default function TrialBanner() {
  const { token } = useAuth();
  const [status, setStatus] = useState<BillingStatus | null>(null);

  useEffect(() => {
    if (!token) return;
    apiFetch("/api/billing/status", { headers: { Authorization: `Bearer ${token}` } })
      .then((r) => (r.ok ? r.json() : null))
      .then(setStatus)
      .catch(() => {});
  }, [token]);

  if (!status || !status.has_org) return null;

  if (status.subscription_status === "trialing") {
    return (
      <div className="bg-forest-600/20 border-b border-forest-600/30 px-4 py-2 flex items-center justify-between text-sm">
        <span className="text-forest-300">
          Trial: <strong>{status.trial_days_left} day{status.trial_days_left !== 1 ? "s" : ""}</strong> remaining
        </span>
        <Link
          to="/app/billing"
          className="text-forest-400 hover:text-forest-300 font-medium underline underline-offset-2"
        >
          Subscribe now
        </Link>
      </div>
    );
  }

  if (status.subscription_status === "past_due") {
    return (
      <div className="bg-amber-600/20 border-b border-amber-600/30 px-4 py-2 flex items-center justify-between text-sm">
        <span className="text-amber-300">Payment failed — update your payment method to avoid losing access.</span>
        <Link
          to="/app/billing"
          className="text-amber-400 hover:text-amber-300 font-medium underline underline-offset-2"
        >
          Update billing
        </Link>
      </div>
    );
  }

  return null;
}
